import { Injectable } from '@angular/core';
// import { ApiHttpClient, FileResponse } from '../../../../modules/tcm-core.module';
import { FileExplorerDeleteFileRequest, FileExplorerMoveFileRequest, FileExplorerRenameFileRequest, FileExplorerRenameFolderRequest, FileExplorerStructureRequest, FileExplorerStructureRespone, FileExplorerUpdateStructureRequest } from '../../../../models/file-explorer';
import { PatientDocumentFolderDescriptor } from '../../../../models/patient-documents';
import { FileResponse } from '../../../../modules/tcm-core.module/models/files/file-response';
import { ApiHttpClient } from '../../../../modules/tcm-core.module/services/api-http-client';

@Injectable()
export class FileExplorerApiService {

  constructor(private readonly httpClient: ApiHttpClient) { }

  public getStructureAsync(patientId: number, timeout?: Promise<any>): Promise<FileExplorerStructureRespone> {
    const request: FileExplorerStructureRequest = { patientId: patientId };
    return this.httpClient.postJsonAsync(this.getUrl('/GetStructure'), request, timeout);
  }

  public updateStructureAsync(structure: PatientDocumentFolderDescriptor[], patientId: number, timeout?: Promise<any>): Promise<any> {
    const request: FileExplorerUpdateStructureRequest = { structure: structure, patientId: patientId };
    return this.httpClient.postJsonAsync(this.getUrl('/UpdateStructure'), request, timeout);
  }

  public downloadFileAsync(id: number, timeout?: Promise<any>): Promise<FileResponse> {
    return this.httpClient.getFileAsync('PatientDocuments/Download?id=' + id, timeout);
  }

  async downloadAndDisplayFileAsync(id: number): Promise<any> {
    try {
      const fileResponse = await this.downloadFileAsync(id);
      await fileResponse.displayFileAsync();
    }
    catch (e) { }
  }

  public deleteFileAsync(id: number, timeout?: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('PatientDocuments/Delete', id, timeout);
  }

  public deleteFilesAsync(patientId: number, path: string, timeout?: Promise<any>): Promise<any> {
    const request: FileExplorerDeleteFileRequest = { patientId: patientId, path: path };
    return this.httpClient.postJsonAsync(this.getUrl('/Delete'), request, timeout);
  }

  public renameAsync(id: number, newName: string, timeout?: Promise<any>): Promise<any> {
    const request: FileExplorerRenameFileRequest = { id: id, newName: newName };
    return this.httpClient.postJsonAsync(this.getUrl('/Rename'), request, timeout);
  }

  public renameFolderAsync(patientId: number, oldPath: string, newPath: string, timeout?: Promise<any>): Promise<any> {
    const request: FileExplorerRenameFolderRequest = { patientId: patientId, oldPath: oldPath, newPath: newPath };
    return this.httpClient.postJsonAsync(this.getUrl('/RenameFolder'), request, timeout);
  }

  public moveFileAsync(id: number, newPath: string, timeout?: Promise<any>): Promise<any> {
    const request: FileExplorerMoveFileRequest = { id: id, newPath: newPath };
    return this.httpClient.postJsonAsync(this.getUrl('/Move'), request, timeout);
  }

  private getUrl(methodName: string) : string {
    return `FileExplorer${methodName}`;
  }
}
